import React, { useState, useEffect, useMemo } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import QtModal from "../../../components/Modal/QtModal";
import ArModal from "../../../components/Modal/ArModal";
import ItemTable from "../../../components/Content/ItemTable";
import Summary from "../../../components/Footer/SummaryBilofsale";
import FormAction from "../../../components/Actions/FormAction";
import PaymentModal from "../../../components/Modal/PaymentModal";

// Model
import { soMasterModel } from "../../../../model/SellProducts/SoMasterModel";
import { soDetailModel } from "../../../../model/SellProducts/SoDetailModel";

// Utils
import {
  getData,
  getDataWithComp,
  getByDocId,
  getDocType,
  getTransType,
  getAlert,
  formatCurrency,
  parseCurrency,
  deleteData,
  randomDelay,
  getDataWithJoin,
  searchItemsWithStock,
  getMaxInvNo,
  getMaxDsrNo,
  getMaxCsNo,
  createSetRecNo,
  getMaxRecNoForTest,
} from "../../../../utils/SamuiUtils";

import {
  formatStringDateToDate,
  formatDateOnChange,
  formatDateTime,
  formatThaiDateUi,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
} from "../../../../utils/DateUtils";

import { manageWhItemData } from "../../../../utils/WarehouseUtils";

function Form({
  callInitialize,
  mode,
  name,
  maxDocNo,
  onRowSelected,
  getReport,
  isSidebarOpen,
}) {
  const [formMasterList, setFormMasterList] = useState(soMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [tbDocType, setTbDocType] = useState([]);
  const [tbTransType, setTbTransType] = useState([]);
  const [qtDataList, setQtDataList] = useState([]);
  const [arDataList, setArDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);
  const [grandTotal, setGrandTotal] = useState(0);
  const [rawAmountReceived, setRawAmountReceived] = useState(
    grandTotal.toString()
  );
  const [changeAmount, setChangeAmount] = useState(formatCurrency(0));
  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  // const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);

  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);

  // การแสดงสถานะเอกสาร
  const [statusTransportName, setStatusTransportName] = useState("");
  const [statusTransportColour, setStatusTransportColour] = useState("");
  const [statusPaidName, setStatusPaidName] = useState("");
  const [statusPaidColour, setStatusPaidColour] = useState("");
  const [statusPaidTypeName, setStatusPaidTypeName] = useState("");
  const [statusPaidTypeColour, setStatusPaidTypeColour] = useState("");

  // สำหรับเก็บประเภทการชำระเงิน
  const [paymentType, setPaymentType] = useState({});
  const [paymentAmount, setPaymentAmount] = useState({});

  // เก็บตัวแปรสำหรับเช็ค
  const [chequeNo, setChequeNo] = useState("");
  const [chequeName, setChequeName] = useState("");
  const [chequeBranch, setChequeBranch] = useState("");

  const [base64Image, setBase64Image] = useState("");
  const [amountReceived, setAmountReceived] = useState(
    formatCurrency(grandTotal)
  );

  // สำหรับเช็กเงื่อนไขว่าสร้างวางบิลหรือยัง ?
  const [isBl, setIsBl] = useState(false);

  // สำหรับตัวแปรดักป้องกันการกดซ้ำ
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // สำหรับ Freeze หน้าจอตอนทำรายการ
  const [isLoading, setIsLoading] = useState(false);
  const [isPrint, setIsPrint] = useState(false);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      // เคลียร์ค่าทุกครั้งที่เปิดหน้าจอมา
      setFormMasterList(soMasterModel());
      setFormDetailList([]);

      const companyId = localStorage.getItem("company");
      const whId = localStorage.getItem("WHID")
        ? Number(localStorage.getItem("WHID"))
        : null;

      // โหลดข้อมูลทั้งหมดพร้อมกัน
      const [docTypeList, transTypeList, qtDataListRes, arList, whList] =
        await Promise.all([
          getDocType(2),
          getTransType(),
          Axios.post(
            `${process.env.REACT_APP_API_URL}/api/get-qt-by-so`,
            { comp_id: companyId },
            { headers: { key: process.env.REACT_APP_ANALYTICS_KEY } }
          ),
          getDataWithComp("Tb_Set_AR", "ORDER BY AR_Id ASC"),
          getDataWithComp(
            "Tb_Set_Wh",
            `AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`
          ),
        ]);

      // Set state ทันที
      setTbDocType(docTypeList || []);
      setTbTransType(transTypeList || []);
      setQtDataList(qtDataListRes.data || []);
      setArDataList(arList || []);
      setWhDataList(whList || []);

      // เลือกลูกค้ารายแรก ถ้าเป็น mode "I"
      if (arList?.length && mode === "I") {
        await onRowSelectAr(arList[0]);
      }

      // ไม่ต้องโหลดสินค้าทั้งหมดตอนเริ่มต้น (ปล่อยให้ Modal โหลดเองเมื่อเปิด)
      // const itemDataList = await searchItemsWithStock(...)
      setItemDataList(null);

      // ถ้าแก้ไขข้อมูลให้โหลดข้อมูลจากฐาน
      if (mode === "U") {
        await getModelByNo(arList); // ส่ง arList ที่โหลดมาให้เลย
      } else {
        setShowItemModal(true);
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const getModelByNo = async (arDataList) => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      const resH = await getDataWithComp("SO_H", `AND Doc_No='${maxDocNo}' `);
      console.debug("maxDocNo resH", maxDocNo, resH);
      const fromDatabase = Array.isArray(resH) ? resH[0] : resH;
      if (!fromDatabase) throw new Error("ไม่พบข้อมูลเอกสาร");

      // ค้นหาข้อมูลผู้ขายด้วย AR_ID
      const fromViewAr = arDataList.find(
        (ap) => ap.AR_Id === fromDatabase.AR_ID
      );

      if (!fromViewAr) {
        setIsLoading(false);
        throw new Error("ไม่พบข้อมูลลูกค้า");
      }

      // ค้นหาข้อมูล VIEW
      const resView = await getDataWithComp(
        "API_0701_SO_H",
        `AND Doc_No='${maxDocNo}' `
      );
      const fromView = Array.isArray(resView) ? resView[0] : resView;
      if (!fromView) throw new Error("ไม่พบข้อมูลจากวิวเอกสาร");
      setStatusTransportName(fromView.DocStatusTransport_Name);
      setStatusTransportColour(fromView.DocStatusTransport_Colour);
      setStatusPaidName(fromView.DocStatusPaid_Name);
      setStatusPaidColour(fromView.DocStatusPaid_Colour);
      setStatusPaidTypeName(fromView.DocStatusPaid_Type_Name);
      setStatusPaidTypeColour(fromView.DocStatusPaidType_Colour);

      // สำหรับเช็กเงื่อนไขว่าสร้างวางบิลหรือยัง ?
      const findBlBySoId = await getData(
        "BL_D",
        `SO_Id = ${fromDatabase.Doc_Id}`
      );
      if (findBlBySoId && findBlBySoId.length > 0) {
        setIsBl(true);
      }

      // ฟังก์ชันเพื่อดึงข้อมูล itemOnHand และอัปเดตทีหลัง
      const updateItemOnHandLater = async (newRow, whId, itemId, itemQty) => {
        try {
          // ดึงข้อมูลทั้งหมดในครั้งเดียว
          const [itemOnHandData] = await Promise.all([
            getDataWithComp(
              "API_1101_WH_ITEM_ONHAND",
              `AND WH_Id = ${parseCurrency(whId)} AND Item_Id = ${parseCurrency(
                itemId
              )}`
            ),
          ]);

          if (!itemOnHandData || itemOnHandData.length === 0) {
            newRow.itemOnHand = 0;
          } else {
            let newItemOnHand = parseCurrency(itemOnHandData[0].Item_Onhand);

            newItemOnHand += parseCurrency(itemQty) || 0;
            newRow.itemOnHand = newItemOnHand;
          }

          // อัปเดต UI
          setFormDetailList((prevDetails) =>
            prevDetails.map((detail) =>
              detail.itemId === newRow.itemId
                ? { ...detail, itemOnHand: newRow.itemOnHand }
                : detail
            )
          );
        } catch (error) {
          setIsLoading(false);
          getAlert("FAILED", error.message || error);
        }
      };

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        const itemDisType = String(itemSelected.Item_DisType);
        let itemTotal = itemQty * itemPriceUnit;

        itemTotal -=
          itemDisType === "2"
            ? (itemDiscount / 100) * itemTotal // ลดตามเปอร์เซ็นต์
            : itemDiscount; // ลดตามจำนวนเงิน

        const newRow = {
          ...soDetailModel(index + 1),
          dtId: itemSelected.DT_Id,
          docId: itemSelected.Doc_ID,
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit),
          itemDiscount: formatCurrency(itemDiscount),
          itemDisType,
          itemTotal,
          itemStatus: itemSelected.Item_Status,
          dsSeq: itemSelected.DS_SEQ,
          whId: itemSelected.WH_Id,
          isGift: itemSelected.IsFree === "Y" ? true : false,

          itemOnHand: "-",
        };

        if (itemSelected.WH_Id != null) {
          updateItemOnHandLater(
            newRow,
            itemSelected.WH_Id,
            itemSelected.Item_Id,
            itemQty
          );
        }

        return newRow; // ส่ง newRow กลับทันที
      };

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromDetail = await getByDocId(
        "SO_D",
        fromDatabase.Doc_Id,
        `ORDER BY Line ASC`
      );

      if (fromDetail.length > 0) {
        const newFormDetails = fromDetail.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );

        setFormDetailList(newFormDetails);

        setFormMasterList({
          docId: fromDatabase.Doc_Id,
          compId: fromDatabase.Comp_Id,
          docNo: fromDatabase.Doc_No,
          docDate: formatThaiDateUi(fromDatabase.Doc_Date || null),
          docStatus: fromDatabase.Doc_Status,
          docStatusTransport: fromDatabase.Doc_Status_Transport,
          docStatusReceive: fromDatabase.Doc_Status_Receive,
          docStatusPaid: fromDatabase.Doc_Status_Paid,
          docStatusPaidType: fromDatabase.Doc_Status_Paid_Type,
          docCode: fromDatabase.Doc_Code,
          docType: fromDatabase.Doc_Type,
          docFor: fromDatabase.Doc_For,
          docIsPickingList: fromDatabase.Doc_Is_PickingList,
          docIsInv: fromDatabase.Doc_Is_INV,
          docInvNo: fromDatabase.Doc_INV_No,
          docIsInvFrom: fromDatabase.Doc_Is_INV_From,
          refDocID: fromDatabase.Ref_DocID,
          refDoc: fromDatabase.Ref_Doc,
          refDocDate: formatThaiDateUi(fromDatabase.Ref_DocDate || null),
          refProjectID: fromDatabase.Ref_ProjectID,
          refProjectNo: fromDatabase.Ref_ProjectNo,
          transportType: fromDatabase.Transport_Type,
          docRemark1: fromDatabase.Doc_Remark1,
          docRemark2: fromDatabase.Doc_Remark2,
          arID: fromDatabase.AR_ID,
          arCode: fromDatabase.AR_Code,
          docDueDate: formatThaiDateUi(fromDatabase.Doc_DueDate || null),
          actionHold: fromDatabase.Action_Hold,
          discountValue: fromDatabase.Discount_Value,
          discountValueType: fromDatabase.Discount_Value_Type,
          discountCash: fromDatabase.Discount_Cash,
          discountCashType: fromDatabase.Discount_Cash_Type,
          discountTransport: fromDatabase.Discount_Transport,
          discountTransportType: fromDatabase.Discount_Transport_Type,
          isVat: fromDatabase.IsVat,
          docSEQ: fromDatabase.Doc_SEQ,
          creditTerm: fromDatabase.CreditTerm,
          creditTerm1Day: fromDatabase.CreditTerm1Day,
          creditTerm1Remark: fromDatabase.CreditTerm1Remark,
          creditTerm2Remark: fromDatabase.CreditTerm2Remark,
          accCode: fromDatabase.ACC_Code,
          empName: fromDatabase.EmpName,
          createdDate: setCreateDateTime(fromDatabase.Created_Date || null),
          createdByName: fromDatabase.Created_By_Name,
          createdById: fromDatabase.Created_By_Id,
          updateDate: setCreateDateTime(fromDatabase.Update_Date || null),
          updateByName: fromDatabase.Update_By_Name,
          updateById: fromDatabase.Update_By_Id,
          approvedDate: setCreateDateTime(fromDatabase.Approved_Date || null),
          approvedByName: fromDatabase.Approved_By_Name,
          approvedById: fromDatabase.Approved_By_Id,
          cancelDate: setCreateDateTime(fromDatabase.Cancel_Date || null),
          cancelByName: fromDatabase.Cancel_By_Name,
          cancelById: fromDatabase.Cancel_By_Id,
          approvedMemo: fromDatabase.Approved_Memo,
          printedStatus: fromDatabase.Printed_Status,
          printedDate: setCreateDateTime(fromDatabase.Printed_Date || null),
          printedBy: fromDatabase.Printed_By,
          docPaidPic: fromDatabase.Doc_Paid_Pic,
          payTotal: fromDatabase.Pay_Total,
          refBillNo: fromDatabase.Ref_Bill_No,
          docSoReceiveDate: formatThaiDateUi(
            fromDatabase.Doc_SO_Receive_Date || null
          ),

          arName: fromViewAr.AR_Name,
          arAdd1: fromViewAr.AR_Add1,
          arAdd2: fromViewAr.AR_Add2,
          arAdd3: fromViewAr.AR_Add3,
          arProvince: fromViewAr.AR_Province,
          arZipcode: fromViewAr.AR_Zipcode,
          arTaxNo: fromViewAr.AR_TaxNo,
        });

        setIsVatChecked(fromDatabase.IsVat === 1);

        const discountValueType = parseCurrency(
          fromDatabase.Discount_Value_Type
        );
        if (!isNaN(discountValueType)) {
          setSelectedDiscountValueType(discountValueType.toString());
        }

        setSelectedDiscountValueType(String(fromDatabase.Discount_Value_Type));
      } else {
        setIsLoading(false);
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message || error);
    }
  };

  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    setSelectedDiscountValueType(
      selectedDiscountValueType === name ? null : name
    );
  };

  useEffect(() => {
    console.debug(" window.electronAPI = ", window.electronAPI);
  }, []);

  const validateData = async () => {
    // ตรวจสอบค่า formMasterList.arID และ formMasterList.arCode
    if (!formMasterList.arID && !formMasterList.arCode) {
      setIsSubmitting(false);
      setIsLoading(false);
      getAlert("FAILED", "กรุณาเลือกลูกค้า");
      return false; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
    }

    // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
    if (!formDetailList || formDetailList.length === 0) {
      setIsSubmitting(false);
      setIsLoading(false);
      getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
      return false; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
    }

    // ตรวจสอบค่าภายใน formDetailList
    let index = 0;
    for (const item of formDetailList) {
      // ทำการตรวจสอบจำนวนสินค้าที่สามารถขายได้อีกรอบ
      // await handleChangeDetail(index, "whId", item.whId);

      if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
        setIsSubmitting(false);
        setIsLoading(false);
        getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
        return false; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
      }
      if (
        formMasterList.arItemFree !== "Y" &&
        (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0)
      ) {
        setIsSubmitting(false);
        setIsLoading(false);
        getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
        return false; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
      }
      if (!item.whId) {
        setIsSubmitting(false);
        setIsLoading(false);
        getAlert(
          "FAILED",
          `ไม่สามารถบันทึกได้เนื่องจากไม่พบคลังสินค้าของสินค้า ${item.itemName}`
        );
        return false; // หยุดการทำงานหาก whId เป็น 13 หรือไม่มีค่า
      }
      if (parseCurrency(item.itemQty) > parseCurrency(item.itemOnHand)) {
        setIsSubmitting(false);
        setIsLoading(false);
        getAlert(
          "FAILED",
          `จํานวนสินค้า ${item.itemName} ไม่พอ กรุณาทำรายการใหม่`
        );
        return false; // หยุดการทำงานหากจํานวนสินค้ามากกว่าจํานวนคงเหลือ
      }

      index++;
    }

    return true;
  };

  const handleSubmit = async (
    docStatusPaid,
    docStatusPaidType,
    isPrint = false
  ) => {
    if (isSubmitting) return getAlert("FAILED", "กรุณารอสักครู่");
    setIsSubmitting(true);
    setIsLoading(true);

    console.time("⏱️ Total handleSubmit");
    const headers = { key: process.env.REACT_APP_ANALYTICS_KEY };
    try {
      // Validation
      console.time("⏱️ 1. Validation");
      if (!formMasterList.arID && !formMasterList.arCode) {
        throw new Error("กรุณาเลือกลูกค้า");
      }
      if (!formDetailList || formDetailList.length === 0) {
        throw new Error("กรุณาเพิ่มรายละเอียดสินค้า");
      }

      for (let index = 0; index < formDetailList.length; index++) {
        const item = formDetailList[index];

        const qty = parseCurrency(item.itemQty);
        const price = parseCurrency(item.itemPriceUnit);
        const onhand = parseCurrency(item.itemOnHand);

        if (!qty || qty === 0) {
          throw new Error(`กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
        }
        if (
          item.isGift !== true &&
          item.isGift !== "Y" &&
          (!price || price === 0)
        ) {
          throw new Error(`กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
        }
        if (!item.whId) {
          throw new Error(`ไม่พบคลังสินค้าของ ${item.itemName}`);
        }
        if (qty > onhand) {
          throw new Error(`จำนวนสินค้า ${item.itemName} ไม่พอ`);
        }
      }
      console.timeEnd("⏱️ 1. Validation");

      console.time("⏱️ 2. Generate Doc Number");
      let newMaxDoc = "UNKNOWN";
      let newMaxRec = null;
      let newDateRec = null;

      // ✅ Optimized: ใช้ limit: 1 เพื่อดึงแค่ record เดียว (เร็วกว่า 10-100 เท่า)
      const masterList = await getDataWithComp(
        "SO_H",
        isVatChecked
          ? `AND Doc_No LIKE '${
              paymentType.credit ? "INV%" : "INV%"
            }' ORDER BY Doc_No DESC`
          : `AND Doc_No LIKE '${
              paymentType.credit ? "DSR%" : "CS%"
            }' ORDER BY Doc_No DESC`,
        1 // limit: 1 = ดึงแค่ record แรก (เร็วกว่าเยอะ!)
      );

      newMaxDoc = isVatChecked
        ? getMaxInvNo(masterList)
        : paymentType.credit
        ? getMaxDsrNo(masterList)
        : getMaxCsNo(masterList);

      if (isVatChecked && !paymentType.credit) {
        const findMaxRecNo = await getData(
          "Tb_Set_Rec_No",
          `1 = 1 ORDER BY RecNo DESC`
        );
        newMaxRec = getMaxRecNoForTest(findMaxRecNo);
        newDateRec = getCreateDateTime();
        await createSetRecNo(newMaxRec);
      }
      console.timeEnd("⏱️ 2. Generate Doc Number");

      // สร้าง Header
      console.time("⏱️ 3. Prepare Header Data");
      const formMasterData = {
        comp_id: localStorage.getItem("company"),
        doc_no: newMaxDoc,
        doc_date: formatStringDateToDate(formMasterList.docDate),
        doc_status: 2,
        doc_status_transport: 3,
        doc_status_receive: 3,
        doc_status_paid: docStatusPaid,
        doc_status_paid_type: docStatusPaidType,
        doc_code: 7,
        doc_type: formMasterList.docType,
        doc_for: formMasterList.docFor,
        doc_is_picking_list: 0,
        doc_is_inv: "N",
        doc_inv_no: newMaxRec,
        doc_is_inv_from: 0,
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_doc_date: formatThaiDateUiToDate(formMasterList.refDocDate),
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ar_id: parseCurrency(formMasterList.arID),
        ar_code: formMasterList.arCode,
        doc_due_date: formatStringDateToDate(formMasterList.docDueDate),
        action_hold: 0,
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType),
        discount_cash: 0,
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: 0,
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? 1 : 2,
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency(formMasterList.creditTerm),
        credit_term_1_day: formMasterList.creditTerm1Day,
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: "0000",
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formMasterList.updateDate,
        update_by_name: formMasterList.updateByName,
        update_by_id: formMasterList.updateById,
        cancel_date: formMasterList.cancelDate,
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        printed_status: "N",
        printed_date: formMasterList.printedDate,
        printed_by: formMasterList.printedBy,
        pay_total: 0,
        ref_bill_no: formMasterList.refBillNo,
        doc_so_receive_date: newDateRec
          ? formatThaiDateUiToDate(newDateRec)
          : null,
        doc_paid_pic: base64Image || null,
      };
      console.timeEnd("⏱️ 3. Prepare Header Data");

      // ========================================
      // 🎯 CRITICAL SECTION: ต้องรอให้เสร็จ
      // ========================================
      console.time("⏱️ 4. Create SO Header");
      const respH = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-so-h`,
        formMasterData,
        { headers }
      );
      console.timeEnd("⏱️ 4. Create SO Header");

      if (respH.data.status !== "OK" || !respH.data.doc_id) {
        throw new Error("บันทึกข้อมูลหลักล้มเหลว หรือไม่พบ Doc_Id");
      }

      const docId = respH.data.doc_id;
      const realDocNo = respH.data.doc_no;

      // สร้าง Detail
      console.time("⏱️ 5. Prepare Detail Data");
      const formDetailDataList = formDetailList.map((item, index) => ({
        doc_id: parseCurrency(docId),
        line: index + 1,
        item_id: item.itemId,
        item_code: item.itemCode,
        item_name: item.itemName,
        item_qty: parseCurrency(item.itemQty),
        item_unit: item.itemUnit,
        item_price_unit: parseCurrency(item.itemPriceUnit),
        item_discount: parseCurrency(item.itemDiscount),
        item_distype: item.itemDisType === "2" ? 2 : 1,
        item_total: parseCurrency(item.itemTotal),
        item_status: 1,
        ds_seq: item.dsSeq,
        wh_id: item.whId,
        is_free: item.isGift ? "Y" : "N",
      }));
      console.timeEnd("⏱️ 5. Prepare Detail Data");

      console.time("⏱️ 6. Create SO Detail");
      await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-so-d`,
        { details: formDetailDataList },
        { headers }
      );
      console.timeEnd("⏱️ 6. Create SO Detail");
      console.timeEnd("⏱️ 6. Create SO Detail");
      console.time("⏱️ 7. Save Payment History");
      const paymentTypeMap = {
        cash: 1,
        transfer: 2,
        cheque: 3,
        credit: 4,
        unpaid: 5,
        tiktok: 7,
      };
      const entries = Object.entries(paymentAmount || {});
      const validPayments = entries.filter(([method, amt]) => {
        const v = parseCurrency(amt);
        const typeId = paymentTypeMap[method];
        return v > 0 && [1, 2, 3].includes(typeId);
      });

      console.debug(`💰 Processing ${validPayments.length} payment records...`);

      if (validPayments.length > 0) {
        await Promise.all(
          validPayments.map(([method, amt]) => {
            const v = parseCurrency(amt);
            const typeId = paymentTypeMap[method];
            return Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-pay-history`,
              {
                doc_code_id: 7,
                doc_id: docId,
                pay_type: typeId,
                pay_amount: v,
                pay_remark: null,
                pay_datetime: moment().format("YYYY-MM-DD HH:mm:ss"),
                pay_cheque_no: typeId === 3 ? chequeNo : null,
                pay_cheque_name: typeId === 3 ? chequeName : null,
                pay_cheque_branch: typeId === 3 ? chequeBranch : null,
                pay_by: localStorage.getItem("name"),
                pay_withdrawal: changeAmount,
              },
              { headers }
            );
          })
        );
      }
      console.timeEnd("⏱️ 7. Save Payment History");
      console.timeEnd("⏱️ Total handleSubmit");
      setIsSubmitting(false);
      setIsLoading(false);
      getAlert("OK", "บันทึกบิลสำเร็จ");
      if (isPrint) {
        const path = `"C:\\pb_print_slip\\pb_print_slip.exe" PRD Auto SLIP ${realDocNo}`;
        if (
          window.electronAPI &&
          typeof window.electronAPI.runExe === "function"
        ) {
          await window.electronAPI.runExe(path);
        } else {
          setTimeout(() => {
            getReport("rc", realDocNo);
          }, 300);
        }
      }
      callInitialize();
      setTimeout(async () => {
        const bgStartTime = performance.now();
        console.debug("🔄 === BACKGROUND TASKS START ===");
        console.debug(`📝 Items to process: ${formDetailList.length}`);

        try {
          // 1. อัพเดทคลังสินค้า (ช้าที่สุด)
          console.time("⏱️ BG 1. Update Warehouse (TOTAL)");
          console.debug(
            `🏭 Processing ${formDetailList.length} warehouse items...`
          );

          for (let i = 0; i < formDetailList.length; i++) {
            const item = formDetailList[i];
            console.time(
              `  ⏱️ BG 1.${i + 1}. Warehouse item: ${item.itemName}`
            );

            await manageWhItemData(
              item.itemId,
              item.itemCode,
              item.itemName,
              item.whId,
              "OUT",
              item.itemQty,
              docId,
              newMaxDoc,
              formMasterList.refDoc || newMaxDoc,
              "ขายสินค้า"
            );

            console.timeEnd(
              `  ⏱️ BG 1.${i + 1}. Warehouse item: ${item.itemName}`
            );
          }
          console.timeEnd("⏱️ BG 1. Update Warehouse (TOTAL)");

          // 2. อัพโหลดสลิป (ถ้ามี)
          if (base64Image) {
            console.time("⏱️ BG 2. Upload Slip");
            const slipSize = Math.round(base64Image.length / 1024);
            console.debug(`📷 Uploading slip: ${slipSize} KB`);

            await Axios.post(
              `${process.env.REACT_APP_API_URL}/api/update-so-h-slip`,
              {
                comp_id: localStorage.getItem("company"),
                doc_no: realDocNo,
                doc_paid_pic: base64Image,
              },
              { headers }
            );
            console.timeEnd("⏱️ BG 2. Upload Slip");
          }

          const bgEndTime = performance.now();
          const totalBgTime = bgEndTime - bgStartTime;
          console.debug(`✅ === BACKGROUND TASKS COMPLETED ===`);
          console.debug(
            `🎯 Total Background Time: ${totalBgTime.toFixed(2)}ms (${(
              totalBgTime / 1000
            ).toFixed(2)}s)`
          );
        } catch (bgError) {
          const bgEndTime = performance.now();
          const totalBgTime = bgEndTime - bgStartTime;

          console.error("❌ === BACKGROUND TASK FAILED ===");
          console.error(
            `⏱️ Failed after: ${totalBgTime.toFixed(2)}ms (${(
              totalBgTime / 1000
            ).toFixed(2)}s)`
          );
          console.error("Error:", bgError.message);
          console.error("Details:", {
            docId,
            realDocNo,
            timestamp: new Date().toISOString(),
            error: bgError.message,
            stack: bgError.stack,
          });
        }
      }, 100); // เริ่มทำหลังจาก 100ms
    } catch (error) {
      setIsSubmitting(false);
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const [showPayTypeModal, setShowPayTypeModal] = useState(false);
  const handlePayTypeShow = () => {
    // ตั้งค่าเริ่มต้นเฉพาะตอนเปิด modal
    setAmountReceived((prev) => prev || formatCurrency(grandTotal));
    setRawAmountReceived((prev) => prev || String(grandTotal));
    setShowPayTypeModal(true);
  };

  const handlePayTypeClose = () => {
    setShowPayTypeModal(false);
    setPaymentType({});
    setPaymentAmount({});
  };
  const handleUploadSlip = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUpdate = async () => {
    try {
      setIsLoading(true);
      const headers = { key: process.env.REACT_APP_ANALYTICS_KEY };

      //  ตรวจพื้นฐาน
      if (!formMasterList.arID && !formMasterList.arCode) {
        setIsLoading(false);
        return getAlert("FAILED", "กรุณาเลือกลูกค้า");
      }
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        return getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
      }
      for (const item of formDetailList) {
        const qty = parseCurrency(item.itemQty);
        if (!qty || qty === 0) {
          setIsLoading(false);
          return getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
        }
        if (!item.whId) {
          setIsLoading(false);
          return getAlert(
            "FAILED",
            `ไม่สามารถบันทึกได้เนื่องจากไม่พบคลังสินค้าของสินค้า ${item.itemName}`
          );
        }
      }

      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: formMasterList.docNo,
        doc_date: formatThaiDateUiToDate(formMasterList.docDate),
        doc_status: formMasterList.docStatus,
        doc_status_transport: formMasterList.docStatusTransport,
        doc_status_receive: formMasterList.docStatusReceive,
        doc_status_paid: parseCurrency(formMasterList.docStatusPaid, 10),
        doc_status_paid_type: parseCurrency(
          formMasterList.docStatusPaidType,
          10
        ),
        doc_code: formMasterList.docCode,
        doc_type: formMasterList.docType,
        doc_for: formMasterList.docFor,
        doc_is_picking_list: formMasterList.docIsPickingList,
        doc_is_inv: formMasterList.docIsInv,
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ar_id: formMasterList.arID,
        ar_code: formMasterList.arCode,
        doc_due_date: formatThaiDateUiToDate(formMasterList.docDueDate),
        action_hold: formMasterList.actionHold,
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: formMasterList.discountCash,
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: formMasterList.discountTransport,
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: formMasterList.creditTerm1Day,
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: formMasterList.accCode,
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        cancel_date: formMasterList.cancelDate,
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        printed_status: formMasterList.printedStatus,
        printed_date: formMasterList.printedDate,
        printed_by: formMasterList.printedBy,
        pay_total: formMasterList.payTotal,
        ref_bill_no: formMasterList.refBillNo,
        doc_so_receive_date: formatThaiDateUiToDate(
          formMasterList.docSoReceiveDate
        ),
      };

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-so-h`,
        formMasterData,
        { headers }
      );

      if (response.data.status === "OK") {
        const docId = parseCurrency(formMasterList.docId, 10);

        //  คืนสต็อกของใบเก่าแบบ Promise.all
        const oldDetails = await getDataWithComp(
          "API_0702_SO_D",
          `AND Doc_ID = ${docId}`
        );
        if (oldDetails && oldDetails.length > 0) {
          await Promise.all(
            oldDetails.map((soDetail) =>
              manageWhItemData(
                soDetail.Item_Id,
                soDetail.Item_Code,
                soDetail.Item_Name,
                soDetail.WH_Id,
                "IN",
                soDetail.Item_Qty,
                docId,
                soDetail.Doc_No,
                soDetail.Ref_Doc === null ? soDetail.Doc_No : soDetail.Ref_Doc,
                "แก้ใบขาย"
              )
            )
          );
        }

        //  ลบ detail เดิม แล้วบันทึกใหม่ครั้งเดียว
        await deleteData("SO_D", `WHERE Doc_ID = ${formMasterList.docId}`);
        const formDetailDataList = formDetailList.map((item, index) => ({
          doc_id: parseCurrency(docId, 10),
          line: index + 1,
          item_id: item.itemId,
          item_code: item.itemCode,
          item_name: item.itemName,
          item_qty: parseCurrency(item.itemQty),
          item_unit: item.itemUnit,
          item_price_unit: parseCurrency(item.itemPriceUnit),
          item_discount: parseCurrency(item.itemDiscount),
          item_distype: item.itemDisType,
          item_total: parseCurrency(item.itemTotal),
          item_status: 1,
          ds_seq: item.dsSeq,
          wh_id: item.whId,
          is_free: item.isGift ? "Y" : "N",
        }));

        await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/create-so-d`,
          { details: formDetailDataList },
          { headers }
        );

        //  ตัดสต็อกใหม่แบบ Promise.all
        await Promise.all(
          formDetailList.map((item) =>
            manageWhItemData(
              item.itemId,
              item.itemCode,
              item.itemName,
              item.whId,
              "OUT",
              item.itemQty,
              docId,
              formMasterList.docNo,
              formMasterList.refDoc === null
                ? formMasterList.docNo
                : formMasterList.refDoc,
              "ขายสินค้า"
            )
          )
        );
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdatePayment = async (isPrint = false) => {
    try {
      const headers = { key: process.env.REACT_APP_ANALYTICS_KEY };

      if (!paymentType) {
        return getAlert("FAILED", "กรุณาเลือกประเภทการชำระเงิน");
      }

      //  รวมยอดรับเฉพาะช่องทางที่เป็นเงินเข้า (สด/โอน/เช็ค)
      const channelsForPaid = ["cash", "transfer", "cheque", "tiktok"];
      const totalCollected =
        Object.entries(paymentAmount || {})
          .filter(([m]) => channelsForPaid.includes(m))
          .reduce((sum, [, v]) => sum + (parseCurrency(v) || 0), 0) || 0;

      //  ตัดสินสถานะชำระ
      let docStatusPaid;
      if (paymentType.credit || paymentType.unpaid) {
        docStatusPaid = 2; // ค้างจ่าย
      } else if (totalCollected >= parseCurrency(grandTotal)) {
        docStatusPaid = 3; // จ่ายครบ
      } else {
        docStatusPaid = 2; // จ่ายไม่ครบ
      }

      //  ประเภทช่องทาง ถ้าเลือกช่องทางเดียวให้บันทึก type ตามนั้น
      let docStatusPaidType = 6;
      const selectedMethods = Object.keys(paymentType).filter(
        (method) => paymentType[method]
      );
      if (selectedMethods.length === 1) {
        const map = {
          cash: 1,
          transfer: 2,
          cheque: 3,
          credit: 4,
          unpaid: 5,
          tiktok: 7,
        };
        docStatusPaidType = map[selectedMethods[0]] ?? 6;
      }
      if (mode === "I") {
        await handleSubmit(docStatusPaid, docStatusPaidType, isPrint);
      } else {
        //  อัปเดตยอดชำระฝั่ง Header
        const formPaidData = {
          doc_status: parseCurrency("2", 10),
          doc_status_paid: parseCurrency(docStatusPaid, 10),
          doc_status_paid_type: parseCurrency(docStatusPaidType, 10),
          update_date: formatThaiDateUiToDate(getCreateDateTime()),
          update_by_name: window.localStorage.getItem("name"),
          update_by_id: window.localStorage.getItem("emp_id"),
          doc_no: formMasterList.docNo,
          comp_id: window.localStorage.getItem("company"),
          doc_paid_pic: base64Image,
          // ถ้าอยากเก็บยอดรวมที่รับทั้งหมด:
          pay_total: parseCurrency(String(totalCollected) || "0.00"),
        };

        const docId = parseCurrency(formMasterList.docId, 10);
        const realDocNo = formMasterList.docNo;

        // ========================================
        //  OPTIMISTIC UPDATE: ปิด modal และแสดงผลทันที (ไม่รอ API)
        // ========================================
        handlePayTypeClose(); // ปิด modal ทันที

        if (isPrint) {
          const path = `"C:\\pb_print_slip\\pb_print_slip.exe" PRD Auto SLIP ${realDocNo}`;
          if (
            window.electronAPI &&
            typeof window.electronAPI.runExe === "function"
          ) {
            window.electronAPI.runExe(path).catch((err) => {
              console.error("Print error:", err);
            });
          } else {
            setTimeout(() => {
              getReport("rc", realDocNo);
            }, 300);
          }
        } else {
          getAlert("OK", "แก้ไขรายการใบขายสำเร็จ");
        }

        callInitialize(); // Refresh UI

        // ========================================
        // 🔥 BACKGROUND TASKS: บันทึกทั้งหมดในเบื้องหลัง (Fire-and-Forget)
        // ========================================
        // Capture ค่าทั้งหมดไว้ใน closure เพื่อป้องกันค่าถูกเปลี่ยน
        const backgroundPaymentAmount = { ...paymentAmount };
        const backgroundChequeNo = chequeNo;
        const backgroundChequeName = chequeName;
        const backgroundChequeBranch = chequeBranch;
        const backgroundChangeAmount = changeAmount;

        setTimeout(async () => {
          try {
            // 1. บันทึกบิลหลัก
            const response = await Axios.post(
              `${process.env.REACT_APP_API_URL}/api/update-so-paid`,
              formPaidData,
              { headers }
            );

            if (response.data.status === "OK") {
              // 2. ล้าง Pay_History เดิมก่อน
              await deleteData(
                "Pay_History",
                `WHERE DocCode_Id = 7 AND Doc_Id = ${docId}`
              );

              // 3. สร้าง Pay_History ใหม่ตามช่องทางที่มีจำนวน > 0
              const paymentTypeMap = {
                cash: 1,
                transfer: 2,
                cheque: 3,
                credit: 4,
                unpaid: 5,
                tiktok: 7,
              };

              await Promise.all(
                Object.entries(backgroundPaymentAmount || {})
                  .filter(([method, amt]) => {
                    const v = parseCurrency(amt);
                    const typeId = paymentTypeMap[method];
                    return v > 0 && [1, 2, 3].includes(typeId);
                  })
                  .map(([method, amt]) => {
                    const v = parseCurrency(amt);
                    const typeId = paymentTypeMap[method];
                    return Axios.post(
                      `${process.env.REACT_APP_API_URL}/api/create-pay-history`,
                      {
                        doc_code_id: 7,
                        doc_id: docId,
                        pay_type: typeId,
                        pay_amount: v,
                        pay_remark: null,
                        pay_datetime: moment().format("YYYY-MM-DD HH:mm:ss"),
                        pay_by: localStorage.getItem("name"),
                        pay_cheque_no: typeId === 3 ? backgroundChequeNo : null,
                        pay_cheque_name:
                          typeId === 3 ? backgroundChequeName : null,
                        pay_cheque_branch:
                          typeId === 3 ? backgroundChequeBranch : null,
                        pay_withdrawal: backgroundChangeAmount,
                      },
                      { headers }
                    );
                  })
              );
            }
          } catch (bgError) {
            // ❌ Background task ล้มเหลว - แสดง error ให้ผู้ใช้ทราบ
            console.error("❌ Background save task failed:", bgError);
            console.error("Error details:", {
              docId,
              realDocNo,
              timestamp: new Date().toISOString(),
              error: bgError.message,
              stack: bgError.stack,
            });
            // แสดง error ให้ผู้ใช้ทราบ
            getAlert(
              "FAILED",
              `บันทึกข้อมูลล้มเหลว: ${
                bgError.response?.data?.message || bgError.message
              }`
            );
            // Refresh เพื่อดึงข้อมูลล่าสุด
            callInitialize();
          }
        }, 50); // เริ่มทำหลังจาก 50ms
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  // useEffect(() => {
  //   console.debug("[PaymentModal] grandTotal = ", grandTotal);
  //   setAmountReceived(formatCurrency(grandTotal));
  // }, [grandTotal]);

  // ใช้สำหรับปรับสถานะที่เป็น 'ค้างจ่าย' ให้เป็น 'จ่ายครบ' (เฉพาะเครดิต และ เช็ค)
  const handleUpdatePaidStatus = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formUpdateData = {
        doc_status_paid: parseCurrency("3", 10),
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        doc_no: formMasterList.docNo,
        comp_id: window.localStorage.getItem("company"),
      };
      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-so-paid-complete`,
        formUpdateData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );
      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
      setIsLoading(false);
      // handlePayTypeShow();
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const changetypePaidbyname = (paidTypeNameOrCode) => {
    try {
      // เตรียม mapping และ header
      const headers = { key: process.env.REACT_APP_ANALYTICS_KEY };

      // map ชื่อ → code
      const paidTypeMap = {
        cash: 1,
        transfer: 2,
        cheque: 3,
        credit: 4,
        unpaid: 5,
        mix: 6,
        tiktok: 7,
      };

      const isNumber = /^\d+$/.test(String(paidTypeNameOrCode));
      const paidTypeCode = isNumber
        ? Number(paidTypeNameOrCode)
        : paidTypeMap[String(paidTypeNameOrCode).toLowerCase()];

      if (!paidTypeCode || paidTypeCode < 1 || paidTypeCode > 7) {
        return getAlert(
          "FAILED",
          "ประเภทการชำระไม่ถูกต้อง (ต้องเป็น 1–7 หรือชื่อที่รองรับ)"
        );
      }

      const codeToLabel = {
        1: "เงินสด",
        2: "โอน",
        3: "เช็ค",
        4: "เครดิต",
        5: "ค้างชำระ",
        6: "จ่ายหลายช่องทาง",
        7: "TikTok",
      };

      const newLabel = codeToLabel[paidTypeCode] || `ประเภท ${paidTypeCode}`;

      if (!formMasterList?.docId) {
        return getAlert("FAILED", "ไม่พบ Doc_Id ของเอกสาร");
      }

      // ค่าเดิมในเอกสาร
      const prevCode = Number(formMasterList?.docStatusPaidType);
      const prevLabel =
        codeToLabel[prevCode] ||
        (typeof statusPaidTypeName === "string" &&
        statusPaidTypeName.trim() !== ""
          ? statusPaidTypeName
          : prevCode
          ? `ประเภท ${prevCode}`
          : "ไม่ระบุ");

      if (prevCode === paidTypeCode) {
        return getAlert("INFO", "วิธีการชำระเหมือนเดิม ไม่มีการเปลี่ยนแปลง");
      }

      const actor = window.localStorage.getItem("name") || "-";

      // ยืนยันก่อนเปลี่ยนด้วย C_DIALOG
      const confirmMsg = `ยืนยันการเปลี่ยนวิธีการชำระ?\nจาก “${prevLabel}” เป็น “${newLabel}”`;
      return getAlert("C_DIALOG", confirmMsg, async (confirmed) => {
        if (!confirmed) return;

        setIsLoading(true);
        try {
          const remark = `เปลี่ยนวิธีการชำระจาก ${prevLabel} เป็น ${newLabel}`;
          const remark2 = `โดย ${actor}`;

          // update header
          await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/update-so-h-paid-type`,
            {
              doc_id: parseCurrency(formMasterList.docId, 10),
              comp_id: window.localStorage.getItem("company"),
              doc_status_paid_type: paidTypeCode,
              doc_remark1: remark,
              doc_remark2: remark2,
              update_date: formatThaiDateUiToDate(getCreateDateTime()),
              update_by_name: window.localStorage.getItem("name"),
              update_by_id: window.localStorage.getItem("emp_id"),
            },
            { headers }
          );

          // ถ้าตั้งเป็นค้างชำระ
          if (paidTypeCode === 5) {
            await Axios.post(
              `${process.env.REACT_APP_API_URL}/api/update-so-paid`,
              {
                doc_status: parseCurrency("2", 10),
                doc_status_paid: parseCurrency("2", 10),
                doc_status_paid_type: parseCurrency("5", 10),
                update_date: formatThaiDateUiToDate(getCreateDateTime()),
                update_by_name: window.localStorage.getItem("name"),
                update_by_id: window.localStorage.getItem("emp_id"),
                doc_no: formMasterList.docNo,
                comp_id: window.localStorage.getItem("company"),
                doc_paid_pic: null,
                pay_total: parseCurrency(String(formMasterList?.payTotal ?? 0)),
              },
              { headers }
            );
          }

          // sync UI
          setFormMasterList((prev) => ({
            ...prev,
            docStatusPaidType: paidTypeCode,
            docRemark1: remark,
            ...(paidTypeCode === 5 ? { docStatusPaid: 2 } : {}),
          }));
          setStatusPaidTypeName(newLabel);

          getAlert(
            "OK",
            paidTypeCode === 5 ? "ตั้งค้างชำระสำเร็จ" : "แก้ไขวิธีการชำระสำเร็จ"
          );
          window.location.reload();
        } catch (error) {
          getAlert("FAILED", error?.response?.data?.message || error?.message);
        } finally {
          setIsLoading(false);
        }
      });
    } catch (error) {
      getAlert("FAILED", error?.message || "เกิดข้อผิดพลาดที่ไม่คาดคิด");
    }
  };

  const handleCancel = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        docId: formMasterList.docId,
        doc_no: formMasterList.docNo,
        doc_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-so-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // คืนสต็อกคลัง เมื่อทำการยกเลิก (คุณทรายแจ้งมา)
      const findOldDetail = await getDataWithComp(
        "API_0702_SO_D",
        `AND Doc_ID = '${formMasterList.docId}' ORDER By Line ASC`
      );
      if (findOldDetail && findOldDetail.length > 0) {
        for (const dataDetail of findOldDetail) {
          // ย้ายเข้า
          await manageWhItemData(
            dataDetail.Item_Id, // Item ไอดีของสิ่งนั้นๆ
            dataDetail.Item_Code, // Item โค้ดของสิ่งนั้นๆ
            dataDetail.Item_Name, // ชื่อ Item นั้นๆ
            dataDetail.WH_Id, // WarehouseID ของไอเทม
            "AI", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
            parseCurrency(dataDetail.Item_Qty), // ค่าจำนวนที่กรอกจากหน้าจอ
            dataDetail.Doc_ID, // ไอดีเอกสาร
            dataDetail.Doc_No, // เลขเอกสาร
            dataDetail.Ref_Doc === null
              ? dataDetail.Doc_No
              : dataDetail.Ref_Doc, // เลขเอกสารอ้างอิง
            `ยกเลิกใบ : ${dataDetail.Doc_No}` // หมายเหตุ
          );
        }
      }

      callInitialize();
      getAlert(response.data.status, response.data.message);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdateSlip = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ตรวจสอบค่า formMasterList.arID และ formMasterList.arCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
        if (!item.whId) {
          setIsLoading(false);
          getAlert(
            "FAILED",
            `ไม่สามารถบันทึกได้เนื่องจากไม่พบคลังสินค้าของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหาก whId เป็น 13 หรือไม่มีค่า
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: maxDocNo,
        doc_paid_pic: base64Image,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-so-h-slip`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (mode !== "I" && response.data.status === "OK") {
        // callInitialize();
        // getAlert(response.data.status, response.data.message);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleChangeDateMaster = (value, name) => {
    // ตรวจสอบว่า value เป็น moment object หรือไม่
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;

    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: formatDateOnChange(newValue),
    }));
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;

    if (!/^\d*\.?\d*$/.test(value)) {
      return;
    }

    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeMasterinput = (e) => {
    const { name, value } = e.target;

    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBlurMaster = (e) => {
    const { name, value } = e.target;

    if (value === "." || value === "0.") {
      setFormMasterList((prev) => ({
        ...prev,
        [name]: formatCurrency(0),
      }));
      return;
    }

    // แปลงค่าเป็นตัวเลข และจัดรูปแบบเป็น currency
    const numericValue = parseFloat(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(numericValue);

    setFormMasterList((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));
  };

  const handleFocusMaster = (e) => {
    const { name, value } = e.target;

    // เอาเครื่องหมาย "," ออกจากค่า เพื่อให้พิมพ์ต่อได้ง่ายขึ้น
    const numericValue = value.replace(/,/g, "");

    setFormMasterList((prev) => ({
      ...prev,
      [name]: numericValue || "0", // ถ้าเป็นค่าว่าง ให้เป็น "0"
    }));

    setTimeout(() => e?.target?.select?.(), 0);
  };

  const handleChangeDetail = async (index, field, value) => {
    // ตรวจสอบว่าค่าที่กรอกเข้ามาเป็นตัวเลขหรือตัวเลขที่มีจุดทศนิยม
    if (!/^\d*\.?\d*$/.test(value)) {
      //getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");
      return;
    }

    const updatedList = [...formDetailList];
    updatedList[index][field] = value;

    // -------------------------------------------
    // (กรณี itemQty เดิม ที่ต้องเช็ค stock)
    if (
      field === "itemQty" &&
      (formDetailList[index].itemOnHand === null ||
        formDetailList[index].itemOnHand === undefined)
    ) {
      getAlert("FAILED", "กรุณาเลือกคลังก่อน");
      return;
    }

    if (
      field === "itemQty" &&
      parseCurrency(value) > parseCurrency(formDetailList[index].itemOnHand)
    ) {
      updatedList[index].itemQty = parseCurrency(
        formDetailList[index].itemOnHand
      );
      setTimeout(() => {
        handleBlur(
          index,
          "itemQty",
          String(parseCurrency(formDetailList[index].itemOnHand))
        );
      }, 0);
      getAlert("FAILED", "ไม่สามารถใส่จำนวนเกินกว่าจำนวนคงคลังได้");
      return;
    }

    const itemQty = parseCurrency(updatedList[index].itemQty) || 0;
    const itemPriceUnit = parseCurrency(updatedList[index].itemPriceUnit) || 0;
    const itemDiscount = parseCurrency(updatedList[index].itemDiscount) || 0;
    const itemDisType = String(updatedList[index].itemDisType);

    let itemTotal = itemQty * itemPriceUnit;
    itemTotal -=
      itemDisType === "2" ? (itemDiscount / 100) * itemTotal : itemDiscount;
    updatedList[index].itemTotal = itemTotal;

    if (field === "whId") {
      updatedList[index].itemOnHand = "-";

      const [itemOnHand] = await Promise.all([
        getDataWithComp(
          "API_1101_WH_ITEM_ONHAND",
          `AND WH_Id = ${parseCurrency(value)} AND Item_Id = ${
            updatedList[index].itemId
          }`
        ),
      ]);

      let newItemOnHand = 0;
      if (itemOnHand && itemOnHand.length > 0) {
        newItemOnHand = parseCurrency(itemOnHand[0].Item_Onhand);
      }

      // ดักเงื่อนไขว่า ถ้า itemQty มากกว่า itemOnHand ให้เคลียร์ค่า itemQty
      if (parseCurrency(itemQty) > parseCurrency(newItemOnHand)) {
        updatedList[index].itemQty = formatCurrency("0.00");
      }

      updatedList[index].itemOnHand = newItemOnHand;
      console.debug("itemOnHand", itemOnHand);
    }

    console.debug("updatedList", updatedList);
    setFormDetailList(updatedList);
  };

  const handleFocus = (index, field, event) => {
    const updatedList = [...formDetailList];
    const rawValue = updatedList[index][field];

    updatedList[index][field] =
      parseCurrency((rawValue ?? "").toString().replace(/,/g, "")) || 0;

    setFormDetailList(updatedList);

    // ไฮไลต์ตัวเลขทั้งหมด
    setTimeout(() => {
      event?.target?.select();
    }, 0);
  };

  const handleBlur = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(numericValue);

    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };

  // SET QT
  // const [showQtModal, setShowQtModal] = useState(false);
  // const handleQtShow = () => setShowQtModal(true);
  // const handleQtClose = () => setShowQtModal(false);
  // const onRowSelectQt = async (qtSelected) => {
  //   try {
  //     // เคลียร์ค่าใน formMasterList และ formDetailList
  //     setFormMasterList({});
  //     setFormDetailList([]);

  //     // ค้นหาข้อมูลที่ตรงกับ prSelected.Doc_No ใน PR_H และ AP_ID ใน apDataList
  //     const [fromViewMaster, fromViewAr] = await Promise.all([
  //       getDataWithComp("API_0601_QT_H", "ORDER BY Doc_No DESC"),
  //       arDataList.find((ar) => ar.AR_Id === qtSelected.AR_ID),
  //     ]);

  //     const fromViewQt = fromViewMaster.find(
  //       (qt) => qt.Doc_No === qtSelected.Doc_No
  //     );

  //     if (!fromViewQt || !fromViewAr) {
  //       throw new Error("ไม่พบข้อมูล");
  //     }

  //     // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
  //     const createNewRow = (index, itemSelected) => {
  //       const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
  //       const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
  //       const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
  //       let itemTotal = itemQty * itemPriceUnit;

  //       if (itemSelected.Item_DisType === 2) {
  //         itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
  //       } else {
  //         itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
  //       }

  //       return {
  //         ...soDetailModel(index + 1),
  //         line: itemSelected.Line,
  //         itemId: itemSelected.Item_Id,
  //         itemCode: itemSelected.Item_Code,
  //         itemName: itemSelected.Item_Name,
  //         itemQty,

  //         itemUnit: itemSelected.Item_Unit,
  //         itemPriceUnit: formatCurrency(itemPriceUnit),
  //         itemDiscount: formatCurrency(itemDiscount),
  //         itemDisType: String(itemSelected.Item_DisType),
  //         itemTotal,
  //         itemStatus: itemSelected.Item_Status,
  //         whId: itemSelected.WH_ID,
  //         whName: itemSelected.WH_Name,
  //         zoneId: itemSelected.Zone_ID,
  //         ltId: itemSelected.LT_ID,
  //         dsSeq: itemSelected.DS_SEQ,
  //       };
  //     };

  //     // const getAllItem = await getDataWithComp(
  //     //   "API_0602_QT_D",
  //     //   "ORDER BY Line ASC"
  //     // );
  //     const filterItem = await getDataWithComp(
  //       "API_0602_QT_D",
  //       `AND Doc_No='${qtSelected.Doc_No}' ORDER BY Line ASC`
  //     );

  //     if (filterItem.length > 0) {
  //       const newFormDetails = filterItem.map((item, index) =>
  //         createNewRow(formDetailList.length + index, item)
  //       );

  //       setFormDetailList(newFormDetails);

  //       const firstItem = filterItem[0];

  //       setFormMasterList({
  //         ...formMasterList,
  //         refDocID: fromViewQt.Doc_ID,
  //         refDoc: fromViewQt.Doc_No,
  //         refDocDate: formatThaiDateUi(fromViewQt.Doc_Date),
  //         docDate: formatThaiDateUi(moment()),
  //         docDueDate: formatThaiDateUi(moment()),
  //         docRemark1: fromViewQt.Doc_Remark1,
  //         docRemark2: fromViewQt.Doc_Remark2,
  //         docType: fromViewQt.Doc_Type,
  //         docFor: fromViewQt.Doc_For,
  //         transportType: fromViewQt.Transport_Type,
  //         discountValue: fromViewQt.Discount_Value,
  //         creditTerm: firstItem.CreditTerm,
  //         arID: fromViewQt.AR_ID,
  //         arCode: firstItem.AR_Code,
  //         arName: firstItem.AR_Name,
  //         arAdd1: firstItem.AR_Add1,
  //         arAdd2: firstItem.AR_Add2,
  //         arAdd3: firstItem.AR_Add3,
  //         arProvince: firstItem.AR_Province,
  //         arZipcode: firstItem.AR_Zipcode,
  //         arTaxNo: firstItem.AR_TaxNo,
  //       });

  //       setIsVatChecked(fromViewQt.IsVat === 1 ? true : false);

  //       const discountValueType = parseCurrency(fromViewQt.Discount_Value_Type);
  //       if (!isNaN(discountValueType)) {
  //         setSelectedDiscountValueType(discountValueType.toString());
  //       }
  //     } else {
  //       getAlert(
  //         "FAILED",
  //         `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${qtSelected.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
  //       );
  //     }

  //     handleQtClose(); // ปิด modal หลังจากเลือก
  //   } catch (error) {
  //     getAlert("FAILED", error.message || error);
  //   }
  // };

  // SET AR
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = (arSelected) => {
    console.debug("arSelected", arSelected);
    try {
      setFormMasterList({
        ...formMasterList,
        arID: arSelected.AR_Id,
        arCode: arSelected.AR_Code,
        arName: arSelected.AR_Name,
        arAdd1: arSelected.AR_Add1,
        arAdd2: arSelected.AR_Add2,
        arAdd3: arSelected.AR_Add3,
        arProvince: arSelected.AR_Province,
        arZipcode: arSelected.AR_Zipcode,
        arTaxNo: arSelected.AR_TaxNo,
        arItemFree: arSelected.AR_Item_Free,
      });

      // ถ้าลูกค้ามี VAT ให้ Default VAT
      // if (parseCurrency(arSelected.AR_Vat) === 1) {
      //   setIsVatChecked(true);
      // }

      if (arSelected.AR_Item_Free === "Y") {
        if (formDetailList.length > 0) {
          setFormDetailList([]);
          getAlert(
            "INFO",
            "ลูกค้านี้เป็นลูกค้าฟรี ระบบจะล้างข้อมูลรายการสินค้าโดยอัตโนมัติ"
          );
        }
      }

      handleArClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = async () => {
    // ไม่ต้องโหลดข้อมูลก่อนเปิด Modal (ให้ Modal จัดการเอง)
    setItemDataList(null); // set null to trigger modal internal load if handled
    setShowItemModal(true);
  };
  const handleItemClose = () => setShowItemModal(false);
  const [selectionMode, setSelectionMode] = useState("addQuantity");
  const onRowSelectItem = (itemsSelected) => {
    try {
      console.debug("itemsSelected", itemsSelected);

      setFormDetailList((prevFormDetailList) => {
        let updatedList = [...prevFormDetailList];

        if (updatedList.length === 0) {
          //  ถ้า `formDetailList` ว่างเปล่า → เพิ่มทุก `itemsSelected` เข้าไปเลย
          updatedList = itemsSelected.map((itemSelected) => ({
            line: null,
            itemId: itemSelected.Item_Id,
            itemCode: itemSelected.Item_Code,
            itemName: itemSelected.Item_Name,
            itemQty: formatCurrency(1),
            itemOnHand: formatCurrency(itemSelected.Item_Onhand || 0),
            itemUnit: itemSelected.Item_Unit_ST,
            itemPriceUnit: formatCurrency(itemSelected.Item_Price || 0),
            itemPriceUnit0: formatCurrency(itemSelected.Item_Price || 0),
            itemPriceUnitA: formatCurrency(itemSelected.Item_PriceA || 0),
            itemPriceUnitB: formatCurrency(itemSelected.Item_PriceB || 0),
            itemDiscount: formatCurrency(0),
            itemDisType: "1",
            itemTotal: formatCurrency(itemSelected.Item_Price || 0),
            itemStatus: itemSelected.Item_Status,
            whId: window.localStorage.getItem("WHID")
              ? Number(localStorage.getItem("WHID"))
              : null,
            whName: itemSelected.WH_Name,
            zoneId: null,
            ltId: null,
            dsSeq: formatDateTime(new Date()),
            isGift: itemSelected.Item_Name?.startsWith("Free") || false,
          }));
        } else {
          //  ถ้ามีข้อมูลแล้ว → ใช้โหมด `addQuantity` หรือ `addNewRow`
          itemsSelected.forEach((itemSelected) => {
            const existingItemIndex = updatedList.findIndex(
              (item) => item.itemId === itemSelected.Item_Id
            );

            if (selectionMode === "addQuantity" && existingItemIndex !== -1) {
              //  ถ้าสินค้าซ้ำ → เพิ่มจำนวนและอัปเดต `itemTotal`
              updatedList[existingItemIndex].itemQty = formatCurrency(
                Number(updatedList[existingItemIndex].itemQty) + 1
              );
              updatedList[existingItemIndex].itemTotal = formatCurrency(
                Number(updatedList[existingItemIndex].itemQty) *
                  parseFloat(updatedList[existingItemIndex].itemPriceUnit || 0)
              );
            } else {
              //  เพิ่มแถวใหม่ถ้าอยู่ในโหมด `addNewRow`
              updatedList.push({
                line: null,
                itemId: itemSelected.Item_Id,
                itemCode: itemSelected.Item_Code,
                itemName: itemSelected.Item_Name,
                itemQty: formatCurrency(1),
                itemOnHand: formatCurrency(itemSelected.Item_Onhand || 0),
                itemUnit: itemSelected.Item_Unit_ST,
                itemPriceUnit: formatCurrency(itemSelected.Item_Price || 0),
                itemPriceUnit0: formatCurrency(itemSelected.Item_Price || 0),
                itemPriceUnitA: formatCurrency(itemSelected.Item_PriceA || 0),
                itemPriceUnitB: formatCurrency(itemSelected.Item_PriceB || 0),
                itemDiscount: formatCurrency(0),
                itemDisType: "1",
                itemTotal: formatCurrency(itemSelected.Item_Price || 0),
                itemStatus: itemSelected.Item_Status,
                whId: window.localStorage.getItem("WHID")
                  ? Number(localStorage.getItem("WHID"))
                  : null,
                whName: itemSelected.WH_Name,
                zoneId: null,
                ltId: null,
                dsSeq: formatDateTime(new Date()),
                isGift: itemSelected.Item_Name?.startsWith("Free") || false,
              });
            }
          });
        }

        return updatedList;
      });

      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };
  const onRowSelectItemEnter = (itemsSelected) => {
    try {
      setFormDetailList((prevFormDetailList) => {
        let updatedList = [...prevFormDetailList];

        if (updatedList.length === 0) {
          //  ถ้า `formDetailList` ว่างเปล่า → เพิ่มทุก `itemsSelected` เข้าไปเลย
          updatedList = itemsSelected.map((itemSelected) => ({
            line: null,
            itemId: itemSelected.Item_Id,
            itemCode: itemSelected.Item_Code,
            itemName: itemSelected.Item_Name,
            itemQty: formatCurrency(1),
            itemOnHand: formatCurrency(itemSelected.Item_Onhand || 0),
            itemUnit: itemSelected.Item_Unit_ST,
            itemPriceUnit: formatCurrency(itemSelected.Item_Price || 0),
            itemPriceUnit0: formatCurrency(itemSelected.Item_Price || 0),
            itemPriceUnitA: formatCurrency(itemSelected.Item_PriceA || 0),
            itemPriceUnitB: formatCurrency(itemSelected.Item_PriceB || 0),
            itemDiscount: formatCurrency(0),
            itemDisType: "1",
            itemTotal: formatCurrency(itemSelected.Item_Price || 0),
            itemStatus: itemSelected.Item_Status,
            whId: window.localStorage.getItem("WHID")
              ? Number(localStorage.getItem("WHID"))
              : null,
            whName: itemSelected.WH_Name,
            zoneId: null,
            ltId: null,
            dsSeq: formatDateTime(new Date()),
            isGift: itemSelected.Item_Name?.startsWith("Free") || false,
          }));
        } else {
          //  ถ้ามีข้อมูลแล้ว → ใช้โหมด `addQuantity` หรือ `addNewRow`
          itemsSelected.forEach((itemSelected) => {
            const existingItemIndex = updatedList.findIndex(
              (item) => item.itemId === itemSelected.Item_Id
            );

            if (selectionMode === "addQuantity" && existingItemIndex !== -1) {
              //  ถ้าสินค้าซ้ำ → เพิ่มจำนวนและอัปเดต `itemTotal`
              updatedList[existingItemIndex].itemQty = formatCurrency(
                Number(updatedList[existingItemIndex].itemQty) + 1
              );
              updatedList[existingItemIndex].itemTotal = formatCurrency(
                Number(updatedList[existingItemIndex].itemQty) *
                  parseFloat(updatedList[existingItemIndex].itemPriceUnit || 0)
              );
            } else {
              //  เพิ่มแถวใหม่ถ้าอยู่ในโหมด `addNewRow`
              updatedList.push({
                line: null,
                itemId: itemSelected.Item_Id,
                itemCode: itemSelected.Item_Code,
                itemName: itemSelected.Item_Name,
                itemQty: formatCurrency(1),
                itemOnHand: formatCurrency(itemSelected.Item_Onhand || 0),
                itemUnit: itemSelected.Item_Unit_ST,
                itemPriceUnit: formatCurrency(itemSelected.Item_Price || 0),
                itemPriceUnit0: formatCurrency(itemSelected.Item_Price || 0),
                itemPriceUnitA: formatCurrency(itemSelected.Item_PriceA || 0),
                itemPriceUnitB: formatCurrency(itemSelected.Item_PriceB || 0),
                itemDiscount: formatCurrency(0),
                itemDisType: "1",
                itemTotal: formatCurrency(itemSelected.Item_Price || 0),
                itemStatus: itemSelected.Item_Status,
                whId: window.localStorage.getItem("WHID")
                  ? Number(localStorage.getItem("WHID"))
                  : null,
                whName: itemSelected.WH_Name,
                zoneId: null,
                ltId: null,
                dsSeq: formatDateTime(new Date()),
                isGift: itemSelected.Item_Name?.startsWith("Free") || false,
              });
            }
          });
        }

        return updatedList;
      });
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  const handleDuplicateRow = (index) => {
    const newItem = { ...formDetailList[index] };
    const newList = [
      ...formDetailList.slice(0, index + 1),
      newItem,
      ...formDetailList.slice(index + 1),
    ];
    setFormDetailList(newList);
  };
  const handleRemoveRow = (index) => {
    const newList = formDetailList.filter((_, i) => i !== index);
    setFormDetailList(newList);
  };
  const handleVatChange = () => {
    setIsVatChecked((prev) => !prev);
  };

  // SET WAREHOUSE
  const [showWarehouseModal, setShowWarehouseModal] = useState(false);
  const handleWarehouseShow = () => setShowWarehouseModal(true);
  const handleWarehouseClose = () => setShowWarehouseModal(false);
  const onRowSelectWh = async (whSelected) => {
    // สำหรับ Freeze หน้าจอตอนทำรายการ
    setIsLoading(true);

    handleWarehouseClose();

    if (formDetailList && formDetailList.length > 0) {
      for (let index = 0; index < formDetailList.length; index++) {
        handleChangeDetail(index, "whId", whSelected.WH_Id);
      }
    } else {
      setIsLoading(false);
      getAlert("FAILED", "กรุณาเลือกสินค้าก่อน");
    }

    setIsLoading(false);
  };

  // การคำนวณยอดรวม (totalPrice)
  const totalPrice = useMemo(() => {
    // console.debug("hi", formDetailList);
    return (formDetailList ?? []).reduce(
      (acc, item) => acc + (parseCurrency(item?.itemTotal) || 0),
      0
    );
  }, [formDetailList]);

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    let discountValue = parseCurrency(formMasterList.discountValue || 0);
    let receiptDiscount = 0;

    if (selectedDiscountValueType === "2") {
      // เปอร์เซ็นต์
      receiptDiscount = (totalPrice / 100) * discountValue;
    } else if (selectedDiscountValueType === "1") {
      // จำนวนเงิน
      receiptDiscount = discountValue;
    }

    setReceiptDiscount(receiptDiscount);
  }, [totalPrice, formMasterList.discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    const vat = isVatChecked ? subFinal * 0.07 : 0;
    setVatAmount(parseCurrency(vat.toFixed(2)));
  }, [subFinal, isVatChecked]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const grandTotal = subFinal + vatAmount;
    setGrandTotal(parseCurrency(grandTotal));
  }, [subFinal, vatAmount]);

  const effectiveAmountReceived = useMemo(() => {
    if (paymentType.cash || paymentType.transfer || paymentType.cheque) {
      return parseCurrency(grandTotal);
    }
    return parseCurrency(amountReceived);
  }, [paymentType, grandTotal, amountReceived]);

  const isHiddenPath = () => {
    const hiddenPaths = [
      "/initialdata",
      "/creditor",
      "/debtor",
      "/employee",
      "/tbsetitem",
      "/APtype",
      "/ARtype",
      "/company",
      "/dept",
      "/position",
      "/car",
      "/transType",
      "/docType",
      "/brand",
      "/tb-set-unit",
      "/tb-set-wh",
    ];
    return hiddenPaths.includes(window.location.pathname);
  };

  const handleprint = async () => {
    const path = `"C:\\pb_print_slip\\pb_print_slip.exe" PRD Auto SLIP ${formMasterList?.docNo}`;
    if (window.electronAPI && typeof window.electronAPI.runExe === "function") {
      await window.electronAPI.runExe(path);
    } else {
      setTimeout(() => {
        getReport("rc", formMasterList?.docNo);
      }, 300);
    }
  };

  return (
    <>
      <div
        hidden={
          window.location.pathname === "/bill" ||
          window.location.pathname === "/picking-list"
        }
      >
        <Breadcrumbs
          page={maxDocNo}
          isShowStatus={mode === "U"}
          statusName={statusTransportName}
          statusColour={statusTransportColour}
          statusPaidName={statusPaidName}
          otherStatusColour={statusPaidColour}
          otherTypeName={statusPaidTypeName}
          otherTypeColour={statusPaidTypeColour}
          items={[
            { name: "ขายสินค้า", url: "/sellproducts" },
            { name: name, url: "/billofsale" },
            {
              name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name,
              url: "#",
            },
          ]}
          docIsINV={formMasterList.docIsInv}
          onHandleClick={() => getReport("so", formMasterList.docNo)}
          onHandlePayslip={() => getReport("rc", formMasterList.docNo)}
          onHandleInvoice1={() => getReport("inv1", formMasterList.docInvNo)}
          onHandleInvoice2={() => getReport("inv2", formMasterList.docInvNo)}
          onHandleInvoice3={() => getReport("so_receipt", formMasterList.docNo)}
          urlImg={formMasterList.docPaidPic}
          handleUploadSlip={handleUploadSlip}
          base64Image={base64Image}
          setBase64Image={setBase64Image}
          handleUpdateSlip={handleUpdateSlip}
          docInvNo={formMasterList.docInvNo}
          isVatChecked={isVatChecked}
          isSidebarOpen={isSidebarOpen}
        />
      </div>

      {/* Loading Spinner */}
      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <div className="hidden-scrollbar">
        <div
          className=""
          style={{
            alignItems: "self-start",
            display: "grid",
            gridTemplateColumns: "auto auto",
          }}
        >
          <div
            className="col-6"
            style={{
              alignItems: "self-start",
              display: "grid",
              gridTemplateColumns: "auto auto",
            }}
          >
            <div
              className="col-6"
              style={{ display: "grid", justifyItems: "start" }}
            >
              <div className="" style={{}}>
                <div className="row mt-1">
                  <div className="text-left">
                    <div className="d-flex">
                      <label style={{ width: "120px" }}>วันที่เอกสาร</label>
                      <div style={{ width: "440px" }}>
                        <Datetime
                          className="input-spacing-input-date"
                          name="docDate"
                          value={formMasterList.docDate || null}
                          onChange={(date) =>
                            handleChangeDateMaster(date, "docDate")
                          }
                          dateFormat="DD-MM-YYYY"
                          timeFormat={false}
                          inputProps={{
                            readOnly: true,
                            disabled: mode === "U",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-1" style={{}}>
                  <div className="d-flex align-items-center">
                    <label style={{ width: "120px" }}>วันที่สร้างเอกสาร</label>
                    <input
                      type="text"
                      className="form-control input-spacing"
                      name="createdDate"
                      value={
                        formMasterList.createdDate +
                        " " +
                        formMasterList.createdByName
                      }
                      // onChange={handleChangeMaster}
                      disabled={true}
                      style={{ width: "440px" }}
                    />
                  </div>
                </div>
                <div className=" row mt-1">
                  <div className="d-flex align-items-center">
                    <label style={{ width: "120px" }}>ลูกค้า</label>
                    <div className="input-group" style={{ width: "440px" }}>
                      <input
                        type="text"
                        className="form-control input-spacing"
                        name="apCode"
                        value={
                          (formMasterList.arCode || "") +
                          " " +
                          (formMasterList.arName || "")
                        }
                        onChange={handleChangeMaster}
                        disabled={true}
                        style={{ width: "75%" }}
                      />
                      <button
                        className="btn btn-outline-secondary"
                        onClick={handleArShow}
                        disabled={mode === "U" ? true : false}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </div>
                    <ArModal
                      showArModal={showArModal}
                      handleArClose={handleArClose}
                      arDataList={arDataList}
                      onRowSelectAr={onRowSelectAr}
                    />
                  </div>
                </div>
                <div className=" row mt-1" style={{}}>
                  <div className="d-flex align-items-center">
                    <label style={{ width: "120px" }}>เลขที่ภาษี</label>
                    <input
                      type="text"
                      className="form-control input-spacing"
                      value={formMasterList.arTaxNo || ""}
                      disabled={true}
                      style={{ width: "440px" }}
                    />
                  </div>
                </div>

                <div className=" mt-1" style={{}}>
                  <div className="d-flex align-items-center">
                    <label style={{ width: "120px" }}>ที่อยู่</label>
                    <input
                      type="text"
                      className="form-control input-spacing"
                      name="apAdd1"
                      value={
                        (formMasterList.arAdd1 || "") +
                          "" +
                          (formMasterList.arAdd2 || "") +
                          " " +
                          (formMasterList.arAdd3 || "") +
                          (formMasterList.arProvince || "") +
                          " " +
                          (formMasterList.arZipcode || "") || ""
                      }
                      onChange={handleChangeMaster}
                      disabled={true}
                      style={{ width: "440px" }}
                    />
                  </div>
                </div>

                <div className=" d-flex align-items-center  mt-1">
                  <label style={{ width: "120px" }}>รายละเอียดเอกสาร</label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="docRemark1"
                    value={formMasterList.docRemark1 || ""}
                    onChange={handleChangeMasterinput}
                    disabled={
                      formMasterList.docStatusPaid === 3 ||
                      window.location.pathname === "/bill"
                        ? true
                        : false
                    }
                    style={{ width: "440px" }}
                  />
                </div>

                <div className="d-flex align-items-center  mt-1" style={{}}>
                  <label style={{ width: "120px" }}>หมายเหตุธุรการ</label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="docRemark2"
                    value={formMasterList.docRemark2 || ""}
                    onChange={handleChangeMasterinput}
                    disabled={
                      formMasterList.docStatusPaid === 3 ||
                      window.location.pathname === "/bill"
                        ? true
                        : false
                    }
                    style={{ width: "440px" }}
                  />
                </div>
              </div>

              {mode === "U" ? (
                <div className="mt-5">
                  {window.location.pathname === "/billofsale" ? (
                    statusPaidTypeName === "เครดิต" ? (
                      isVatChecked ? (
                        statusPaidName === "จ่ายครบ" ? (
                          <>
                            <button
                              hidden={isHiddenPath()}
                              onClick={() =>
                                getReport("so", formMasterList.docNo)
                              }
                              className="btn btn-lg shadow text-white"
                              style={{
                                fontSize: "16px",
                                color: "white",
                                marginRight: "10px",
                                fontWeight: "bold",
                                backgroundColor: "purple",
                              }}
                              disabled={true}
                            >
                              <i
                                className="fa fa-print"
                                style={{ fontSize: "16px" }}
                              ></i>
                              &ensp;ใบเสร็จรับเงิน/ใบกำกับภาษี
                            </button>
                            <button
                              hidden={isHiddenPath()}
                              onClick={() =>
                                getReport("so", formMasterList.docNo)
                              }
                              className="btn btn-lg btn-primary"
                              style={{
                                fontSize: "16px",
                                color: "white",
                                marginRight: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              <i
                                className="fa fa-print"
                                style={{ fontSize: "16px" }}
                              ></i>
                              &ensp;ใบส่งของ/ใบกำกับภาษี
                            </button>
                          </>
                        ) : (
                          <button
                            hidden={isHiddenPath()}
                            onClick={() =>
                              getReport("so", formMasterList.docNo)
                            }
                            className="btn btn-lg btn-primary"
                            style={{
                              fontSize: "16px",
                              color: "white",
                              marginRight: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            <i
                              className="fa fa-print"
                              style={{ fontSize: "16px" }}
                            ></i>
                            &ensp;ใบส่งของ/ใบกำกับภาษี
                          </button>
                        )
                      ) : statusPaidName === "จ่ายครบ" ? (
                        <>
                          <button
                            hidden={isHiddenPath()}
                            onClick={() =>
                              getReport("so", formMasterList.docNo)
                            }
                            className="btn btn-lg shadow text-white"
                            style={{
                              fontSize: "16px",
                              color: "white",
                              marginRight: "10px",
                              fontWeight: "bold",
                              backgroundColor: "purple",
                            }}
                            disabled={true}
                          >
                            <i
                              className="fa fa-print"
                              style={{ fontSize: "16px" }}
                            ></i>
                            &ensp;ใบเสร็จรับเงิน
                          </button>
                          <button
                            hidden={isHiddenPath()}
                            onClick={() =>
                              getReport("so", formMasterList.docNo)
                            }
                            className="btn btn-lg btn-primary"
                            style={{
                              fontSize: "16px",
                              color: "white",
                              marginRight: "10px",
                              fontWeight: "bold",
                            }}
                          >
                            <i
                              className="fa fa-print"
                              style={{ fontSize: "16px" }}
                            ></i>
                            &ensp;ใบส่งของ/ใบแจ้งหนี้
                          </button>
                        </>
                      ) : (
                        <button
                          hidden={isHiddenPath()}
                          onClick={() => getReport("so", formMasterList.docNo)}
                          className="btn btn-lg btn-primary"
                          style={{
                            fontSize: "16px",
                            color: "white",
                            marginRight: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          <i
                            className="fa fa-print"
                            style={{ fontSize: "16px" }}
                          ></i>
                          &ensp;ใบส่งของ/ใบแจ้งหนี้
                        </button>
                      )
                    ) : isVatChecked ? (
                      <>
                        <button
                          hidden={
                            window.location.pathname === "/billofsale"
                              ? false
                              : true
                          }
                          onClick={handleprint}
                          className="btn btn-lg btn-success"
                          style={{
                            fontSize: "16px",
                            color: "white",
                            marginRight: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          <i
                            className="fa fa-print"
                            style={{ fontSize: "16px" }}
                          ></i>
                          &ensp;ใบสลิป
                        </button>
                        <button
                          hidden={isHiddenPath()}
                          onClick={() =>
                            getReport("so_receipt", formMasterList.docNo)
                          }
                          className="btn btn-lg shadow text-white"
                          style={{
                            fontSize: "16px",
                            color: "white",
                            marginRight: "10px",
                            fontWeight: "bold",
                            backgroundColor: "purple",
                          }}
                        >
                          <i
                            className="fa fa-print"
                            style={{ fontSize: "16px" }}
                          ></i>
                          &ensp;ใบเสร็จรับเงิน
                        </button>
                        <button
                          hidden={isHiddenPath()}
                          onClick={() => getReport("so", formMasterList.docNo)}
                          className="btn btn-lg btn-primary"
                          style={{
                            fontSize: "16px",
                            color: "white",
                            marginRight: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          <i
                            className="fa fa-print"
                            style={{ fontSize: "16px" }}
                          ></i>
                          &ensp;ใบส่งของ/ใบกำกับภาษี
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          hidden={
                            window.location.pathname === "/billofsale"
                              ? false
                              : true
                          }
                          onClick={handleprint}
                          className="btn btn-lg btn-success"
                          style={{
                            fontSize: "16px",
                            color: "white",
                            marginRight: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          <i
                            className="fa fa-print"
                            style={{ fontSize: "16px" }}
                          ></i>
                          &ensp;ใบสลิป
                        </button>
                        <button
                          hidden={isHiddenPath()}
                          onClick={() => getReport("so", formMasterList.docNo)}
                          className="btn btn-lg btn-primary"
                          style={{
                            fontSize: "16px",
                            color: "white",
                            marginRight: "10px",
                            fontWeight: "bold",
                          }}
                        >
                          <i
                            className="fa fa-print"
                            style={{ fontSize: "16px" }}
                          ></i>
                          &ensp;ใบส่งของ/ใบเสร็จรับเงิน
                        </button>
                      </>
                    )
                  ) : (
                    <>
                      <div className="d-flex gap-2">
                        <button
                          hidden={isHiddenPath()}
                          onClick={() => getReport("so", formMasterList.docNo)}
                          className="btn btn-primary d-flex align-items-center justify-content-center"
                          style={{
                            width: "50px",
                            height: "50px",
                            borderRadius: "50%",
                            fontSize: "16px",
                            color: "white",
                            fontWeight: "bold",
                            padding: 0,
                          }}
                        >
                          <i className="fa fa-print"></i>
                        </button>
                        <div style={{ marginRight: "18px" }} />
                      </div>
                    </>
                  )}
                </div>
              ) : null}
            </div>

            <div
              className="col-6"
              style={{
                display: "grid",
                justifyItems: "start",
                marginLeft: "10px",
              }}
            >
              <div className="" style={{}}>
                <div className="row mt-1" style={{}}>
                  <div className="d-flex align-items-center">
                    <label style={{ width: "120px" }}>วันที่แก้ไขเอกสาร</label>
                    <input
                      type="text"
                      className="form-control input-spacing"
                      name="updateDate"
                      value={
                        formMasterList.updateDate || formMasterList.updateByName
                          ? `${formMasterList.updateDate || ""} ${
                              formMasterList.updateByName || ""
                            }`
                          : ""
                      }
                      disabled={true}
                      style={{ width: "460px" }}
                    />
                  </div>
                </div>
                <div className="row mt-1" style={{}}>
                  <div className="d-flex align-items-center">
                    <label style={{ width: "120px" }}>วันที่ยกเลิกเอกสาร</label>
                    <input
                      type="text"
                      className="form-control input-spacing"
                      name="cancelDate"
                      value={
                        formMasterList.cancelDate || formMasterList.cancelByName
                          ? `${formMasterList.cancelDate || ""} ${
                              formMasterList.cancelByName || ""
                            }`
                          : ""
                      }
                      disabled={true}
                      style={{ width: "460px" }}
                    />
                  </div>
                </div>
                <div className=" row mt-1">
                  <div className="d-flex align-items-center">
                    <label style={{ width: "120px" }}>พนักงาน</label>
                    <div className="input-group" style={{ width: "460px" }}>
                      <input
                        type="text"
                        className="form-control input-spacing"
                        name="emp"
                        value={window.localStorage.getItem("name")}
                        // onChange={handleChangeMaster}
                        disabled={true}
                        style={{ width: "460px" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-8">
            <Summary
              formMasterList={formMasterList}
              handleChangeMaster={handleChangeMaster}
              handleBlurMaster={handleBlurMaster}
              handleFocusMaster={handleFocusMaster}
              selectedDiscountValueType={selectedDiscountValueType}
              handleCheckboxChange={handleCheckboxChange}
              receiptDiscount={receiptDiscount}
              formatCurrency={formatCurrency}
              parseCurrency={parseCurrency}
              totalPrice={totalPrice}
              subFinal={subFinal}
              isVatChecked={isVatChecked}
              handleVatChange={handleVatChange}
              vatAmount={vatAmount}
              grandTotal={grandTotal}
              disabled={
                formMasterList.docStatusPaid === 3 ||
                window.location.pathname === "/bill"
                  ? true
                  : false
              }
            />
          </div>
        </div>

        <div
          className="row mt-2"
          style={{ maxHeight: "80vh", overflowY: "auto" }}
        >
          <ItemTable
            formDetailList={formDetailList}
            handleChangeDetail={handleChangeDetail}
            handleDuplicateRow={handleDuplicateRow}
            handleRemoveRow={handleRemoveRow}
            formatCurrency={formatCurrency}
            showItemModal={showItemModal}
            handleItemClose={handleItemClose}
            itemDataList={itemDataList}
            onRowSelectItem={onRowSelectItem}
            handleItemShow={handleItemShow}
            whDataList={whDataList}
            showWarehouseModal={showWarehouseModal}
            handleWarehouseClose={handleWarehouseClose}
            handleWarehouseShow={handleWarehouseShow}
            onRowSelectWh={onRowSelectWh}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            disabled={
              formMasterList.docStatusPaid === 3 ||
              window.location.pathname === "/bill"
                ? true
                : false
            }
            onRowSelectItemEnter={onRowSelectItemEnter}
            setFormDetailList={setFormDetailList}
            selectionMode={selectionMode}
            setSelectionMode={setSelectionMode}
          />

          <div
            hidden={
              window.location.pathname === "/bill" ||
              window.location.pathname === "/picking-list"
            }
          >
            <PaymentModal
              show={showPayTypeModal}
              grandTotal={grandTotal}
              paymentType={paymentType}
              setPaymentType={setPaymentType}
              paymentAmount={paymentAmount}
              setPaymentAmount={setPaymentAmount}
              handlePayTypeClose={handlePayTypeClose}
              handleUpdatePayment={handleUpdatePayment}
              handleUploadSlip={handleUploadSlip}
              base64Image={base64Image}
              setBase64Image={setBase64Image}
              chequeNo={chequeNo}
              setChequeNo={setChequeNo}
              chequeName={chequeName}
              setChequeName={setChequeName}
              chequeBranch={chequeBranch}
              setChequeBranch={setChequeBranch}
              setIsPrint={setIsPrint}
              amountReceived={amountReceived}
              setAmountReceived={setAmountReceived}
              rawAmountReceived={rawAmountReceived}
              setRawAmountReceived={setRawAmountReceived}
              changeAmount={changeAmount}
              setChangeAmount={setChangeAmount}
              formDetailList={formDetailList}
            />
          </div>
        </div>
      </div>
      <FormAction
        onSubmit={() => {
          const isAllGiftItems =
            formDetailList.length > 0 &&
            formDetailList.every((item) => item.isGift === true);
          if (
            parseCurrency(grandTotal) === 0 &&
            formMasterList.arItemFree === "N" &&
            !isAllGiftItems
          ) {
            getAlert("FAILED", "กรุณาเพิ่มรายการ หรือ ใส่จำนวนเงินก่อนบันทึก");
          } else if (formMasterList.arItemFree === "N") {
            setShowPayTypeModal(true);
          } else {
            setShowConfirmModal(true);
          }
        }}
        onUpdate={async () => {
          if (await validateData()) {
            if (Number(formMasterList.docStatusPaid) === 3) {
              await handleUpdate();
            } else {
              setShowPayTypeModal(true);
            }
          }
        }}
        onCancel={handleCancel}
        onApprovedPay={handlePayTypeShow}
        onUpdatePaid={handleUpdatePaidStatus}
        docStatus={formMasterList.docStatusPaid}
        changetypePaidbyname={changetypePaidbyname}
        mode={mode}
        disabled={false}
        disabledInv={formMasterList.docIsInv === "Y" ? true : false}
        disabledPay={isBl}
        footer={true}
      />

      {/* Confirm Modal */}
      <div
        className={`modal fade ${showConfirmModal ? "show" : ""}`}
        tabIndex="-1"
        style={{ display: showConfirmModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">ยืนยันการบันทึก</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowConfirmModal(false)}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>คุณแน่ใจว่าต้องการบันทึกข้อมูลใบขายหรือไม่?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-lg w-25 shadow text-white d-flex align-items-center justify-content-center"
                style={{ backgroundColor: "#EF6C00", fontSize: "16px" }}
                onClick={async () => {
                  setShowConfirmModal(false);
                  await handleSubmit(0, 0);
                  // callInitialize();
                  // getAlert("OK", "บันทึกข้อมูลใบขายสำเร็จ");
                }}
                disabled={isSubmitting}
              >
                ยืนยัน
              </button>
              <button
                type="button"
                className="btn btn-lg w-25 shadow text-white"
                style={{ backgroundColor: "red", fontSize: "16px" }}
                onClick={() => setShowConfirmModal(false)}
                disabled={isSubmitting}
              >
                ยกเลิก
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Form;
